import { VALIDATION_ATTRIBUTES } from '../vs-form-builder.model';
import {
  alpha,
  alpha_num,
  decimal,
  email,
  numeric,
  required,
  regex,
  notBefore,
  notAfter,
  maxValue,
  minValue,
  url,
  isWeekend,
  isWeekday,
  cardCheck,
  checkboxAllRequired,
  checkboxOneRequired,
  maxRule,
  minRule,
  confirm,
  requiredIf,
  ErrorMessage,
  dateFormat, dateBetween, getFutureDateFromCurrentDay, notWeekend,
}
  from './rules.helper';

/* START GENAI@CHATGPT4 */
// sort the rules based on priority, as of now we will make sure the required rule gets validated first
const sortRulesByPriority = (rules: any[]) => {
  const sortedRules = [...rules];
  sortedRules.sort((a, b) => {
    if (a === VALIDATION_ATTRIBUTES.REQUIRE) {
      return -1;
    }
    if (b === VALIDATION_ATTRIBUTES.REQUIRE) {
      return 1;
    }
    return 0;
  });
  return sortedRules;
};
/* END GENAI@CHATGPT4 */

/* START GENAI@CHATGPT4 */
export const getValidators = (field:any, rules: any) => {
  const validators = [];
  sortRulesByPriority(rules).forEach((rule: string) => {
    if (rule.indexOf(':') > -1) {
      const ruleObj = rule.split(':');
      const ruleKey = ruleObj[0];
      const ruleValue = ruleObj.slice(1).join(':');
      if (ruleKey === VALIDATION_ATTRIBUTES.REGEX) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.REGEX,
          method: regex,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || getDefaultRegexErrorMessage(ruleValue),
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.NOT_BEFORE) {
        const dateRuleConfig = ruleValue.split('|');
        validators.push({
          key: VALIDATION_ATTRIBUTES.NOT_BEFORE,
          method: notBefore,
          config: ruleValue,
          defaultErrorMessage:
            getRuleErrorMessage(field, rule) || `The date should be in '${dateRuleConfig?.[0]}' format, not before ${dateRuleConfig?.[1]}.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.NOT_AFTER) {
        const dateRuleConfig = ruleValue.split('|');
        validators.push({
          key: VALIDATION_ATTRIBUTES.NOT_AFTER,
          method: notAfter,
          config: ruleValue,
          defaultErrorMessage:
            getRuleErrorMessage(field, rule) || `The date should be in '${dateRuleConfig?.[0]}' format, not after ${dateRuleConfig?.[1]}.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.DATE_BETWEEN) {
        const dateRuleConfig = ruleValue.split('|');
        validators.push({
          key: VALIDATION_ATTRIBUTES.DATE_BETWEEN,
          method: dateBetween,
          config: ruleValue,
          defaultErrorMessage:
            getRuleErrorMessage(field, rule) || `Only dates between ${getFutureDateFromCurrentDay(dateRuleConfig[1])} and ${getFutureDateFromCurrentDay(dateRuleConfig[2])} are allowed`,
        });
      }  else if (ruleKey === VALIDATION_ATTRIBUTES.NOT_WEEKEND) {
        const dateRuleConfig = ruleValue.split('|');
        validators.push({
          key: VALIDATION_ATTRIBUTES.NOT_WEEKEND,
          method: notWeekend,
          config: ruleValue,
          defaultErrorMessage:
            getRuleErrorMessage(field, rule) || `Only dates between ${getFutureDateFromCurrentDay(dateRuleConfig[1])} and ${getFutureDateFromCurrentDay(dateRuleConfig[2])} are allowed`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.MAX_VALUE) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.MAX_VALUE,
          method: maxValue,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `The input should be less than ${ruleValue}.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.MIN_VALUE) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.MIN_VALUE,
          method: minValue,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `The input should be more than ${ruleValue}.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.MAX) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.MAX,
          method: maxRule,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please limit length to ${ruleValue} characters.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.MIN) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.MIN,
          method: minRule,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `The input should contain at least ${ruleValue} characters.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.REQUIRE_IF) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.REQUIRE_IF,
          method: requiredIf,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `The input is required when ${ruleValue} is enabled.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.CONFIRM) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.CONFIRM,
          method: confirm,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `The input does not match ${ruleValue}. Please re-enter for confirmation.`,
        });
      } else if (ruleKey === VALIDATION_ATTRIBUTES.DATE_FORMAT) {
        validators.push({
          key: VALIDATION_ATTRIBUTES.DATE_FORMAT,
          method: dateFormat,
          config: ruleValue,
          defaultErrorMessage: getRuleErrorMessage(field, rule) || `Date format should be ${ruleValue}.`,
        });
      }
    } else if (rule === VALIDATION_ATTRIBUTES.EMAIL) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.EMAIL,
        method: email,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter a valid email.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.NUMERIC || rule === VALIDATION_ATTRIBUTES.NUMBER) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.NUMERIC,
        method: numeric,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter numeric value only.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.REQUIRE) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.REQUIRE,
        method: required,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `This field is required.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.ALPHA) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.ALPHA,
        method: alpha,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter alpha characters only.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.ALPHA_NUMERIC) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.ALPHA_NUMERIC,
        method: alpha_num,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter alpha number characters only.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.DECIMAL) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.DECIMAL,
        method: decimal,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter decimal number only.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.URL) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.URL,
        method: url,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter a valid URL.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.WEEKEND) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.WEEKEND,
        method: isWeekend,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter a valid weekend.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.WEEKDAY) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.WEEKDAY,
        method: isWeekday,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter a valid weekday.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.CARD) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.CARD,
        method: cardCheck,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please enter a valid card number.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.ALL_REQUIRED) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.ALL_REQUIRED,
        method: checkboxAllRequired,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please select all options to continue.`,
      });
    } else if (rule === VALIDATION_ATTRIBUTES.ONE_REQUIRED) {
      validators.push({
        key: VALIDATION_ATTRIBUTES.ONE_REQUIRED,
        method: checkboxOneRequired,
        defaultErrorMessage: getRuleErrorMessage(field, rule) || `Please select at least one option to continue.`,
      });
    } else {
      console.warn(`Unknown validator rule "${rule}"`);
    }
  });
  return validators;
};

/* START GENAI@GHCOPILOT */
/**
 * Validates the input value against the provided validators.
 *
 * This function iterates over an array of validator objects, each containing a validation method,
 * configuration, and a default error message. It applies each validation method to the input value
 * and stops at the first validation failure, returning the corresponding error message.
 *
 * @param {Array<{ method: Function, config: any, defaultErrorMessage: string, key: string }>} validators - Array of validator objects.
 * @param {string} value - The input value to validate.
 * @returns {{ valid: boolean, errorMessage: string | null }} - An object with validation status and error message.
 */
export const checkValidations = (validators:any = [], value: string) => {
  let isValid = true;
  let errorMessage = null;

  validators?.every((validator:
                      { method: any; config: any; defaultErrorMessage: any; key: string }) => {
    const { method, config, defaultErrorMessage } = validator;
    if (!method(value, config)) {
      errorMessage = defaultErrorMessage;
      isValid = false;
      return false;
    }
    return true;
  });

  return { valid: isValid, errorMessage } as ErrorMessage;
};
/* END GENAI@GHCOPILOT */

export const getDefaultRegexErrorMessage = (ruleValue: string) => {
  /* START GENAI@CHATGPT4 */
  return ruleValue === '^[0-9]+\\.[0-9][0-9]$' ?
    'Please enter a number with 2 decimal place' :
    `The input should follow this regex rule: ${ruleValue}`;
  /* END GENAI@CHATGPT4 */
};

/* START GENAI@GHCOPILOT */
/**
 * Determines the valid state of a field based on its required status and current value.
 *
 * @param isRequired - A boolean indicating if the field is required.
 * @param value - The current value of the field.
 * @param validationAttr - An object containing the validation attributes of the field.
 * @returns A boolean indicating if the field is valid.
 */
export const getValidStateAccordingToRequiredStatus = (isRequired: boolean, value: string, validationAttr: any) => {
  // If the field is not required and the value is empty or null, return true (valid).
  if (!isRequired && (value?.length === 0 || !value)) {
    return true;
  } else {
    // Otherwise, return the validity status from the validation attributes.
    return validationAttr.valid;
  }
};
/* END GENAI@GHCOPILOT */

export const getRules = (field: any): string[] => {
  return Object.keys(field?.rules || {});
};

export const getRuleErrorMessage = (field: any, rule: string): string => {
  return field?.rules?.[rule];
}

export const getFieldValidators = (field: any) => {
  const rules = getRules(field);
  return getValidators(field, rules);
};

export const getInputRenderCss = (singleColumn: string, isTwoColumnsPerRow: boolean, toDisplay: boolean = false) => {
  /**
   * Get the CSS class for input rendering based on column and display settings.
   * @param {string} singleColumn - Whether the input should be rendered in a single column.
   * @param {boolean} isTwoColumnsPerRow - Whether the input should be rendered in two columns per row.
   * @param {boolean} [toDisplay=false] - Whether the input should be displayed.
   * @returns {string} - The CSS class for input rendering.
   */
  /* START GENAI@GHCOPILOT */
  return !toDisplay ? "display-none" : (singleColumn === 'true' ? 'vs-col-12 vs-pl-0' : (isTwoColumnsPerRow ? 'vs-col-md-6 vs-pl-0' : 'vs-col-12 vs-pl-0'));
  /* END GENAI@GHCOPILOT */
};

/* END GENAI@CHATGPT4 */
